import api from "@/api/api-v2-config";

export async function getCustomersListAxios() {    
    return await api.get("customers?pageNumber=1&pageSize=10000");
}

export async function deleteCustomersAxios(id) {    
    return await api.delete("customers/" + id);
}

export async function postCustomersAxios(customers) {    
    return await api.post("customers", customers);
}

export async function putCustomersAxios(customers) {    
    return await api.put("customers", customers);
}

export async function getCustomersByIDAxios(id) {    
    return await api.get("customers/" + id);
}

export async function getOrdersByIDAxios(id) {    
    return await api.get("customers/" + id + "/orders");
}

export async function getQuotationsByIDAxios(id) {    
    return await api.get("customers/" + id + "/quotes");
}

export async function getServiceRequestsByIDAxios(id) {    
    return await api.get("customers/" + id + "/ServiceRequests");
}

export async function getInvoicesByIDAxios(id) {    
    return await api.get("customers/" + id + "/invoices");
}


export async function getOpportunityBCustomers(id) {
    return await api.get("customers/" + id + "/opportunities");
}

export async function getCustomerProfileDetail(id) {
    return await api.get("customers/" + id + "/profile");
}

export async function postCustomerProfileDetail(payload) {
    return await api.post("customers/profile/detail",payload);
}

export async function getProfileDetailsList(){
    return await api.get("customers/profile/detail?pageNumber=1&pageSize=10000");
}

export async function getComplaintByCustomers(id) {
    return await api.get("customers/" + id + "/complaints");
}

export async function deleteCustomersProfileDetail(id) {    
    return await api.delete("customers/profile/detail/" + id);
}